<div class="container main-font pl-0 pr-0">
  <div class="row mx-3 pt-1 g-4">
    <div class="col-xl-12 app-card">
      <app-card-lista-teams></app-card-lista-teams>
    </div>
  </div>
</div>
